const cleanString = (string: string): string => string.replace(/\s+/g, ' ').trim()

export default cleanString
